export const getOmnisendEventPrice = (duration, totals = {}) => {
  const priceByDuration = {
    '6 months': totals?.sixMonths,
    '3 months': totals?.threeMonths,
    '90 days': totals?.threeMonthsOneOff,
    '1 month': totals?.oneMonth,
    '30 days': totals?.oneMonth,
  };
  const price = Number.parseFloat(priceByDuration[duration] || 0);

  return Number.isFinite(price) ? Math.round(price) : 0;
};

export const sendOmnisendAddToCartEvent = async ({
  addOmnisendEventMutation,
  email,
  url,
  subscribtion,
  totals,
}) => {
  if (!email) {
    console.log('Skipping Omnisend add-to-cart event: missing email');
    return false;
  }

  try {
    await addOmnisendEventMutation({
      email,
      url,
      subscribtion,
      price: getOmnisendEventPrice(subscribtion?.duration, totals),
    }).unwrap();

    return true;
  } catch (err) {
    console.log('Error event ', err);
    return false;
  }
};
